import React, {useState, useContext,useEffect,useRef, useMemo } from "react";
import { AppContext } from "../../components/AppProvider";
import { Document, Page, pdfjs } from 'react-pdf';
import styled from "styled-components";
import { Fragment } from "react";
import { createPortal } from 'react-dom';
import imgArrowCircleDown from "../../resources/preReg/images/ebooth/arrow_circle_down.svg";
import imgExample from "../../resources/preReg/images/ebooth/img4.png";
import imgExample1 from "../../resources/preReg/images/ebooth/image 8.png";
import imgComplete from "../../resources/preReg/images/ebooth/complete.svg";
import imgClose from "../../resources/preReg/images/ebooth/close.svg";
import imgCheck from "../../resources/preReg/images/ebooth/Checkbox_wrapper.svg";
import imgBackbtn from "../../resources/preReg/images/ebooth/backbtn.svg";
import imgOpenIn from "../../resources/preReg/images/ebooth/open_in_new.svg";
import imgOpenIn2 from "../../resources/preReg/images/ebooth/open_in_new2.svg";

import imgFullscreen from "../../resources/preReg/images/ebooth/FullScreen.svg";
import imgFullscreenClose from "../../resources/preReg/images/ebooth/FullScreenClose.svg"; 
import imgNext from "../../resources/preReg/images/ebooth/Next.svg";
import imgPrev from "../../resources/preReg/images/ebooth/Prev.svg";
import imgZoomIn from "../../resources/preReg/images/ebooth/ZoomIn.svg";
import imgZoomOut from "../../resources/preReg/images/ebooth/ZoomOut.svg";

import useStore from "../../modules/utils/store";
import { _API, _CK } from "../../modules/utils";
import moment from "moment";
import Cookies from "universal-cookie";

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

// PDF.js canvas 렌더링 성능 개선: getImageData 반복 호출 시 GPU→CPU 플러시 방지
if (typeof HTMLCanvasElement !== 'undefined') {
  const _origGetContext = HTMLCanvasElement.prototype.getContext;
  HTMLCanvasElement.prototype.getContext = function(type, attrs) {
    if (type === '2d') {
      return _origGetContext.call(this, type, { willReadFrequently: true, ...attrs });
    }
    return _origGetContext.call(this, type, attrs);
  };
}


const EboothModal = (props) => {
  const { siteInfo } = useStore();
  const { iam } = useContext(AppContext);
  const cm = new Cookies();
  const [hideToday, setHideToday] = useState(cm.get(iam.preregIdx) != null ? true : false);
  const [viewDetail, setViewDetail] = useState(false);
  const [contentType, setContentType] = useState('EDIT');
  const [pdfUrl, setPdfUrl] = useState('');
  const [numPages, setNumPages] = useState(null); 
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [currentPage, setCurrentPage] = useState(1);  // 현재 페이지 상태 추가
  const [scale, setScale] = useState(1.0);  // 줌 상태 추가
  const pdfWrapperRef = useRef(null);
  const [pdfWidth, setPdfWidth] = useState(800);
  const [isFullscreen, setIsFullscreen] = useState(false); // 전체화면 상태 추가
  const { setEboothModalShow, eboothSiteSetting, eboothEventSetting, eboothSectionItem, eboothItem, eboothList,loadEboothInfo } = props;

  const pdfOptions = useMemo(() => ({
    cMapUrl: '/cmaps/',
    cMapPacked: true,
    disableFontFace: false,
    disableRange: false,
    disableStream: false,
    rangeChunkSize: 65536,
  }), []);
 
  // Detail 정보
  const [eboothIdx, setEeboothIdx] = useState(false);
  const [attendYn, setAttendYn] = useState(false);
  const [detailTitle, setDetailTitle] = useState(false);
  const [detailImg, setDetailImg] = useState(false);
  const [detailMore, setDetailMore] = useState(false);
  const [detailMoreUrl, setDetailMoreUrl] = useState(false);
  const [detailCompany, setDetailCompany] = useState(false);
  const [detailTel, setDetailTel] = useState(false);
  const [detailEmail, setDetailEmail] = useState(false);
  const [detailHomepage, setDetailHomepage] = useState(false);
  const [detailMoreShow, setDetailMoreShow] = useState(false);
  const [detailCompanyShow, setDetailCompanyShow] = useState(false);
  const [detailTelShow, setDetailTelShow] = useState(false);
  const [detailEmailShow, setDetailEmailShow] = useState(false);
  const [detailHomepageShow, setDetailHomepageShow] = useState(false);
  const [detailContents, setDetailContents] = useState("");
  
  const hasTitle = eboothList?.some(item => item.title);

  const [isPageChanging, setIsPageChanging] = useState(false);

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    if (pdfWrapperRef.current) {
      setPdfWidth(pdfWrapperRef.current.clientWidth || pdfWrapperRef.current.offsetWidth);
      
      // PDF 로드 후 스타일 업데이트
      setTimeout(() => {
        updateAlignmentIfNeeded();
      }, 200);
    }
  };
  const modalClose = () => {
    // body 스크롤 다시 활성화
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    
    setEboothModalShow(false);
    // 모달이 닫힐 때 viewDetail을 false로 설정하여 모달을 초기 상태로 돌려놓음
    setViewDetail(false);
    // 현재 페이지를 1로 재설정
    setCurrentPage(1);
    // 줌 상태도 초기화
    setScale(1.0);
  };
  const handleCheckboxChange = () => {
    const today = !hideToday
    if(today == true){
      //하루는 86400초
      cm.set(iam.preregIdx, {cDate : moment().format('YYYY-MM-DD'), eventIdx : siteInfo.idx}, { path: "/", sameSite: "lax", maxAge: 86400});
    }else{
      cm.remove(iam.preregIdx)
    }
    setHideToday(today);
  };
  const itemRefs = useRef([]);
  const handleScroll = (index) => {
    // targetRef.current이 실제 DOM 엘리먼트를 참조합니다.
    // 예를 들어, 해당 엘리먼트로 스크롤 이동하는 코드는 다음과 같을 수 있습니다.
    if (itemRefs.current[index]) {
      itemRefs.current[index].scrollIntoView({ behavior: 'smooth' });
    }
  };
  const saveAfter = (name) => {
    loadEboothInfo();
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= numPages) {
      // 페이지 변경 중임을 표시
      setIsPageChanging(true);
      
      setCurrentPage(newPage);
      
      // 페이지 변경 시 확대/축소 상태를 원본 크기로 초기화
      setScale(1.0);
      
      // 페이지 변경 후 약간의 지연 시간을 두고 스타일 업데이트
      setTimeout(() => {
        updateAlignmentIfNeeded();
        
        // PDF 컨테이너의 스크롤을 맨 위로 올림 (전체화면 및 일반 모드 모두)
        if (pdfWrapperRef.current) {
          // 세로 스크롤 초기화
          pdfWrapperRef.current.scrollTop = 0;
          
          // 가로 스크롤도 초기화
          pdfWrapperRef.current.scrollLeft = 0;
          
          // 전체 모달의 스크롤도 초기화
          if (!isFullscreen) {
            const modalContent = document.querySelector('.content');
            if (modalContent) {
              modalContent.scrollTop = 0;
            }
          }
        }
        
        // 페이지 변경 완료
        setIsPageChanging(false);
      }, 300);
    }
  };

  const zoomIn = () => {
    setScale(prevScale => {
      const newScale = Math.min(prevScale + 0.2, 2.5);
      return newScale;
    });
    
    // 약간의 지연 후 정렬 방식 업데이트
    setTimeout(() => {
      updateAlignmentIfNeeded();
    }, 100);
  };

  const zoomOut = () => {
    setScale(prevScale => {
      const newScale = Math.max(prevScale - 0.2, 0.5);
      return newScale;
    });
    
    // 약간의 지연 후 정렬 방식 업데이트
    setTimeout(() => {
      updateAlignmentIfNeeded();
    }, 100);
  };
  
  // 정렬 방식 업데이트 함수
  const updateAlignmentIfNeeded = () => {
    if (!pdfWrapperRef.current) return;

    // --- 모든 읽기(Read) 먼저 ---
    const pdfPage = pdfWrapperRef.current.querySelector('.react-pdf__Page__canvas');
    if (!pdfPage) return;

    const pdfPageWidth = pdfPage.offsetWidth;
    const containerWidth = isFullscreen
      ? window.innerWidth - 40
      : pdfWrapperRef.current.offsetWidth - 40;

    const pdfContainer = pdfWrapperRef.current;
    const pdfDocument = pdfWrapperRef.current.querySelector('.react-pdf__Document');
    const allPages = pdfWrapperRef.current.querySelectorAll('.react-pdf__Page');

    // 각 페이지의 하위 요소를 읽기 단계에서 모두 수집
    const pageElements = Array.from(allPages).map(page => ({
      textLayer: page.querySelector('.react-pdf__Page__textContent'),
      canvas: page.querySelector('canvas'),
    }));

    // --- 모든 쓰기(Write) 나중에 ---
    const alignValue = pdfPageWidth > containerWidth ? 'flex-start' : 'center';
    pdfContainer.style.alignItems = alignValue;
    if (pdfDocument) pdfDocument.style.alignItems = alignValue;

    pageElements.forEach(({ textLayer, canvas }) => {
      if (textLayer) {
        textLayer.style.width = '100%';
        textLayer.style.height = '100%';
        textLayer.style.overflow = 'hidden';
      }
      if (canvas) {
        canvas.style.display = 'block';
        canvas.style.margin = '0 auto';
      }
    });
  };


  const gotoDetail = (item) => {
    // 상세 보기로 진입할 때 항상 페이지를 1로 초기화
    setCurrentPage(1);
    // 확대/축소 상태도 초기화
    setScale(1.0);
    
    setViewDetail(true)
    if(item?.attendYn == "N" && eboothEventSetting?.attendCompleteStandard == "ACCESS"){
      const req = {
        path: "/v1/client/ebooth/attend",
        data: {
          eboothIdx : item.idx
          ,preregIdx : iam.preregIdx
        },
      };
      _API.post(req).then((res) => {
        const { insertId } = res.data;
        console.log(res.data)
        if(insertId > 0){
          saveAfter();
        }
      }).catch((e) => {
        console.log(e)
      });
    }
    setEeboothIdx(item.idx == null ? "" : item.idx)
    setAttendYn(item.attendYn == null ? "" : item.attendYn)
    setDetailTitle(item.name == null ? "" : item.name)
    setDetailImg(item.img == null ? "" : item.img)
    setDetailMore(item.detailViewLabel == null ? "" : item.detailViewLabel)
    setDetailMoreUrl(item.detailViewUrl == null ? "" : item.detailViewUrl)
    setDetailCompany(item.companyName == null ? "" : item.companyName)
    setDetailTel(item.tel == null ? "" : item.tel)
    setDetailEmail(item.email == null ? "" : item.email)
    setDetailHomepage(item.homepageUrl == null ? "" : item.homepageUrl)
    setDetailMoreShow(item.detailViewShow == null || item.detailViewShow == 'N' ? false : true)
    setDetailCompanyShow(item.companyNameShow == null || item.companyNameShow == 'N' ? false : true)
    setDetailTelShow(item.telShow == null || item.telShow == 'N' ? false : true)
    setDetailEmailShow(item.emailShow == null || item.emailShow == 'N' ? false : true)
    setDetailHomepageShow(item.homepageUrlShow == null || item.homepageUrlShow == 'N' ? false : true)
    setDetailContents(item.contents)
    setContentType(item.contentType);
    setPdfUrl(item.pdfUrl);
  };
  
  const detailMoreClick = (eboothIdx,attendYn,detailMoreUrl) => {
    if(attendYn == "N" && eboothEventSetting?.attendCompleteStandard == "DETAIL"){
      const req = {
        path: "/v1/client/ebooth/attend",
        data: {
          eboothIdx : eboothIdx
          ,preregIdx : iam.preregIdx
        },
      };
      _API.post(req).then((res) => {
        const { insertId } = res.data;
        console.log(res.data)
        if(insertId > 0){
          saveAfter();
        }
      }).catch((e) => {
        console.log(e)
      });
    }
    const url = detailMoreUrl.substring(0, 7) == "http://" || detailMoreUrl.substring(0, 8) == "https://" ? detailMoreUrl : `http://`+detailMoreUrl;
    window.open('about:blank').location.href =  url;
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    // 초기 마운트 시에 이벤트 핸들러 등록
    window.addEventListener('resize', handleResize);

    // 컴포넌트가 언마운트될 때 이벤트 핸들러 해제
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const updateWidth = () => {
      if (pdfWrapperRef.current) {
        setPdfWidth(pdfWrapperRef.current.clientWidth || pdfWrapperRef.current.offsetWidth);
      }
    };
  
    updateWidth();
    window.addEventListener("resize", updateWidth);
  
    if (viewDetail && contentType === 'PDF') {
      setTimeout(updateWidth, 100);
    }
  
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [viewDetail, contentType]);

  // viewDetail 상태가 변경될 때 페이지 및 확대/축소 초기화
  useEffect(() => {
    if (!viewDetail) {
      // 상세 보기 모드가 아닐 때 (목록 보기로 돌아갔을 때)
      setCurrentPage(1);
      setScale(1.0);
    }
  }, [viewDetail]);

  // isFullscreen 상태가 변경될 때 창 크기 이벤트 발생시키기
  useEffect(() => {
    if (!isFullscreen) {
      // 전체화면 모드에서 나올 때 창 크기 이벤트 트리거
      window.dispatchEvent(new Event('resize'));
    }
  }, [isFullscreen]);

  // scale, 창 크기, 페이지 변경 시 정렬 방식 업데이트
  useEffect(() => {
    // PDF가 로드된 후 약간의 지연을 두고 정렬 방식 업데이트
    const timer = setTimeout(updateAlignmentIfNeeded, 300);
    
    // 창 크기 변경 시에도 정렬 업데이트
    window.addEventListener('resize', updateAlignmentIfNeeded);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateAlignmentIfNeeded);
    };
  }, [scale, isFullscreen, currentPage, numPages]);

  // 전체화면 토글 함수
  const toggleFullscreen = () => {
    const newIsFullscreen = !isFullscreen;
    setIsFullscreen(newIsFullscreen);
    
    // 전체화면 모드 전환 후 PDF 크기 재조정
    if (newIsFullscreen) {
      // 전체화면에서는 body의 스크롤 상태 유지 (모달 자체가 이미 스크롤을 막고 있음)
    } else {
      // 전체화면 종료 시 확대/축소 상태 초기화
      setScale(1.0);
      
      // 모달 내 PDF 크기 재조정
      setTimeout(() => {
        if (pdfWrapperRef.current) {
          setPdfWidth(pdfWrapperRef.current.clientWidth || pdfWrapperRef.current.offsetWidth);
          // 스크롤 위치 초기화
          pdfWrapperRef.current.scrollLeft = 0;
          
          // 정렬 상태 업데이트
          setTimeout(updateAlignmentIfNeeded, 200);
        }
      }, 100);
    }
  };

  // useEffect를 추가하여 컴포넌트가 마운트될 때 body 스크롤 비활성화
  useEffect(() => {
    // 현재 스크롤바 너비 계산
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    
    // 모달이 열리면 body 스크롤 비활성화하고 패딩으로 스크롤바 자리 확보
    document.body.style.overflow = 'hidden';
    // 스크롤바 너비만큼 우측 패딩 추가하여 콘텐츠 점프 방지
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    
    // 컴포넌트가 언마운트될 때 body 스크롤 다시 활성화
    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, []);

  return (
    <Fragment>
      <EboothContainer className="ebooth_container">
        {eboothEventSetting != null &&
        <>
          <div className="header">
            {!viewDetail ? (
              <h2>{eboothEventSetting?.pageName}</h2>
            ) : (
              <div>
                <img src={imgBackbtn} style={{cursor:"pointer"}} onClick={()=>{
                  setViewDetail(false);
                  // 뒤로가기 버튼 클릭 시 페이지와 줌 상태 초기화
                  setCurrentPage(1);
                  setScale(1.0);
                }} />
                <h2>{detailTitle}</h2>
              </div>
            )}
            <button className="close_btn" onClick={modalClose}><img src={imgClose}/></button>
          </div>
          {(hasTitle && !viewDetail) && (
            <ul className="tag_list">
              {eboothList?.map((item,index) => (
                item?.title && (
                  <li key={index}>
                    <a onClick={() => handleScroll(index)}>
                      {item?.title}
                      <img src={imgArrowCircleDown} />
                    </a>
                  </li>)
              ))}
            </ul>
          )}
          <div className="content">
            {!viewDetail ? (
              <>
                {(eboothEventSetting.intro != null && eboothEventSetting.intro != "") &&
                  <p className="ebooth_desc" dangerouslySetInnerHTML={{ __html: eboothEventSetting.intro }}>
                  </p>
                }
                <div className="ebooth_content_inner">
                  {eboothList?.map((item, index) => (
                    <div className="content_cont" key={index} ref={(el) => (itemRefs.current[index] = el)}>
                      {(eboothEventSetting.sectionUse == "Y") && (eboothEventSetting.sectionNameUse == "Y") ? (<h3>{item?.title}</h3>) : "" }
                      {(eboothEventSetting.sectionUse == "Y") && (eboothEventSetting.sectionIntroUse == "Y") ? (<span dangerouslySetInnerHTML={{ __html: item?.desc }}></span>) : "" }
                      <div className="content_cont_inner">
                        <ul className="content_list">
                          {item.list.map((j,jIndex) => (
                            <li key={j?.idx ?? jIndex}
                              style={{
                                width: `${item.column == "2" ? "calc(50% - 18px)"
                                  :item.column == "3" ? "calc(33.33% - 24px)"
                                  : item.column == "4" ? "calc(25% - 27px)" : ""}`,
                                flex: `${item.column == "2" && isMobile ? "0 0 80%"
                                  :item.column == "3" && isMobile ? "0 0 70%"
                                  :item.column == "4" && isMobile ? "0 0 60%":""}`
                              }}
                            >
                              <div className="content_list_inner" onClick={()=>{gotoDetail(j)}}>
                                <div>
                                  <img src={j?.img} className="photo_img" />
                                  {(j.attendYn == "Y" && eboothEventSetting?.attendCompleteStampUse == "Y") && (
                                    <div className="complete_box">
                                      <img src={imgComplete} className="complete_img" />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <h4>{j?.name}</h4>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="view_detail">
                {/* <img src={detailImg}/> */}
                {contentType == 'EDIT' ? (
                  <div dangerouslySetInnerHTML={{ __html: detailContents }} ></div>
                ) : (
                  <>
                    {isFullscreen ? (
                      createPortal(
                        <PDFFullscreenContainer>
                          <div className="pdf-wrapper" ref={pdfWrapperRef}>
                            <Document
                              file={pdfUrl}
                              options={pdfOptions}
                              onLoadSuccess={onLoadSuccess}
                              loading={<div className="pdf-loading">PDF 로딩 중...</div>}
                              error={<div className="pdf-error">PDF를 불러올 수 없습니다</div>}
                            >
                              {isPageChanging ? (
                                <div className="page-loading">페이지 변경 중...</div>
                              ) : (
                                <Page
                                  pageNumber={currentPage}
                                  width={window.innerWidth * 0.95 - 40}
                                  scale={scale}
                                  className="pdf-page pdf-fullscreen-page"
                                  renderTextLayer={false}
                                  renderAnnotationLayer={false}
                                  devicePixelRatio={1}
                                />
                              )}
                            </Document>
                            <div className="page-navigation">
                              <div className="nav-controls">
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage <= 1}><img src={imgPrev} alt="이전" /></button>
                                <span>Page {currentPage} of {numPages}</span>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= numPages}><img src={imgNext} alt="다음" /></button>
                              </div>
                              <div className="view-controls">
                                <button onClick={zoomOut} disabled={scale <= 0.5}><img src={imgZoomOut} alt="축소" /></button>
                                <button onClick={zoomIn} disabled={scale >= 2}><img src={imgZoomIn} alt="확대" /></button>
                                <button className="fullscreen-btn" onClick={toggleFullscreen}>
                                  <img src={imgFullscreenClose} alt="전체화면 종료" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </PDFFullscreenContainer>,
                        document.body
                      )
                    ) : (
                      <div ref={pdfWrapperRef} className="pdf-container">
                        <Document
                          file={pdfUrl}
                          options={pdfOptions}
                          onLoadSuccess={onLoadSuccess}
                          loading={<div className="pdf-loading">PDF 로딩 중...</div>}
                          error={<div className="pdf-error">PDF를 불러올 수 없습니다</div>}
                        >
                          {isPageChanging ? (
                            <div className="page-loading">페이지 변경 중...</div>
                          ) : (
                            <Page
                              pageNumber={currentPage}
                              width={pdfWidth * 0.9}
                              scale={scale}
                              className="pdf-page"
                              renderTextLayer={false}
                              renderAnnotationLayer={false}
                              devicePixelRatio={1}
                            />
                          )}
                        </Document>
                        <div className="page-navigation">
                          <div className="nav-controls">
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage <= 1}><img src={imgPrev} alt="이전" /></button>
                            <span>Page {currentPage} of {numPages}</span>
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= numPages}><img src={imgNext} alt="다음" /></button>
                          </div>
                          <div className="view-controls">
                            {/* <button onClick={zoomOut} disabled={scale <= 0.5}>축소</button>
                            <button onClick={zoomIn} disabled={scale >= 2}>확대</button> */}
                            <button className="fullscreen-btn" onClick={toggleFullscreen}>
                              <img src={imgFullscreen} alt="전체화면" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {detailMoreShow && <button><a onClick={()=>{detailMoreClick(eboothIdx,attendYn,detailMoreUrl)}} target={`_blank`} >{detailMore}</a></button>}
                  {(detailCompanyShow || detailTelShow || detailEmailShow || detailHomepageShow) && (
                  <ul>
                    {detailCompanyShow && <li><h5>조직명</h5><p>{detailCompany}</p></li>}
                    {detailTelShow && <li><h5>연락처</h5><p>{detailTel}</p></li>}
                    {detailEmailShow && <li><h5>이메일</h5><p>{detailEmail}</p></li>}
                    {detailHomepageShow && 
                    <li>
                      <h5>홈페이지</h5>
                      <p>
                        <a href={detailHomepage.substring(0, 7) == "http://" || detailHomepage.substring(0, 8) == "https://" ? detailHomepage : `http://`+detailHomepage} target={`_blank`} >
                          {detailHomepage}<img src={imgOpenIn2} />
                        </a>
                      </p>
                    </li>
                  }
                  </ul>  
                )}
              </div>
            )}
          </div>
          <div className="btm">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={hideToday}
                  onChange={(e) => handleCheckboxChange(e)}
                  className="checkbox-input"
                
                />
                {hideToday ? (
                  <img src={imgCheck}/>
                ):<span className="checkbox-custom"></span>}
                <span className="checkbox-custom-text">오늘 하루 동안 보지 않기</span>
              </label>
            <div className="close_box"><button onClick={modalClose}>닫기</button></div>
          </div>
        </>
        }
      </EboothContainer>
    </Fragment>
  );
};

export default EboothModal;

const PDFFullscreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  
  .fullscreen-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  
  .pdf-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-x: auto;
    overflow-y: auto; /* 세로 스크롤 활성화 */
    width: 100%;
    justify-content: space-between;
    padding-top:20px;
  }
  
  .pdf-page {
    margin-bottom: 20px;
    transform-origin: left top;
  }
  
  .pdf-fullscreen-page {
    margin-left: 0;
    display: block;
    margin: 0 auto;
  }
  
  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .react-pdf__Page {
    max-width: none !important;
    transition: transform 0.2s ease; /* 트랜지션 효과 추가 */
  }
  
  .react-pdf__Page__textContent {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
  .react-pdf__Page__canvas {
    display: block;
    margin: 0 auto;
  }
  
  .page-navigation {
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    gap: 8px;
    z-index: 1;
  }
  
  .nav-controls, 
  .view-controls {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .nav-controls span{
    font-size:15px;
    line-height:22px;
    color:#404040;
    font-weight:400;
  }
  
  button {
    padding: 8px 8px;
    background: #f3f2ff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #464F60;
  }
  button img{display:block;}
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .fullscreen-btn {
    background: #f3f2ff;
    color: white;
  }

  .page-loading {
    width: 100%;
    padding: 100px 0;
    text-align: center;
    font-size: 16px;
    color: #5959EF;
    background: #f8f8ff;
    border-radius: 8px;
    margin: 20px 0;
  }
`;

const EboothContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display:flex;
  flex-direction: column;
  width: 90%;
  max-width: 1240px;
  max-height: calc(100vh - 120px);
  height: 100%;
  border-radius: 6px;
  overflow-y:auto;
  background: #fff;
  gap:20px;
  
  @media (orientation: landscape) and (max-width: 950px) and (max-device-height: 500px){
    top:unset;
    left:unset;
    transform:unset;
    width:100%;
    height:100%;
  }
  img {display:block;}
  
  /* PDF 컨테이너 기본 스타일 */

  
  .pdf-container .nav-controls,
  .pdf-container .view-controls {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  
  .pdf-container button {
    padding: 6px 12px;
    background: #EBEBF8;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .pdf-container .fullscreen-btn {
    background: #5959EF;
    color: white;
  }
  
  .pdf-container button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 30px 0 30px;
  }
  .header h2{font-size: 26px; font-weight: 900; line-height: 34px; color:#1a1a1a;}
  .tag_list{display:flex; align-items: center; justify-content: flex-start; gap:4px; margin: 0 30px;}
  .tag_list li{background: #EBEBF8; border-radius:4px;}
  .tag_list li a{display:flex; align-items: center; color:#464f60; font-size:13px; font-weight:500; line-height:18px; gap: 4px; padding: 6px 8px; cursor:pointer;}
  .tag_list li a:hover,.tag_list li a:focus{color:#464f60;}
  .content{
    flex: 1 1 auto; 
    overflow-y:auto;
    &::-webkit-scrollbar {
      width: 6px;
      border-radius: 4px;
      background: #EFEFEF;
    }
    &::-webkit-scrollbar-thumb {
      background: #A1A1A1;
      border-radius: 4px;
    }
  }
  .content .ebooth_desc{
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color:#646464;
    margin:0 30px 20px 30px;
    padding-bottom:20px;
  }
  .ebooth_content_inner{display:flex; flex-direction:column; row-gap:60px; margin-bottom:60px; padding-bottom:20px;}
  .content_cont h3{
    display: flex;
    align-items: center;
    flex-basis: 100%;
    font-size: 24px;
    font-weight: 700;
    line-height: 33px;
    color:#5959EF;
    margin:0 30px 24px 30px
  }
  .content_cont h3:before{
    content: "";
    flex-grow: 1;
    width: auto;
    height: 1px;
    background: #5959EF;
    font-size: 0;
    line-height: 0;
    margin-right: 30px;
  }
  .content_cont h3:after{
    content: "";
    flex-grow: 1;
    width: auto;
    height: 1px;
    background: #5959EF;
    font-size: 0;
    line-height: 0;
    margin-left: 30px;
  }
  .content_cont span{display:block; font-size: 15px; font-weight: 400;
line-height: 22px; color:#646464; margin:0 30px 24px 30px;}
  .content_list{
    display:flex;
    flex-wrap:wrap;
    column-gap: 36px;
    row-gap: 40px;
    margin:0 30px;
    &::-webkit-scrollbar {
      height: 6px;
      border-radius: 4px;
      background: #EFEFEF;
    }
    &::-webkit-scrollbar-thumb {
      background: #A1A1A1;
      border-radius: 4px;
    }
  }
  .content_list li > .content_list_inner{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    cursor:pointer;
  }
  .content_list li > .content_list_inner:after{
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  .content_list li > .content_list_inner > div{
    position:absolute; display: flex;
    align-items: center; height:100%; background:#F0EFF6; width:100%;
  }
  .content_list li > h4{
    margin-top:20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; 
    color:#1a1a1a;
  }
  .content_list li img.photo_img{width:100%}
  .content_list li .complete_box{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.8);
  }
  .content_list li img.complete_img{position: absolute; bottom: 3.5%; right: 3.5%; width: 35%; font-size: 0;}
  .btm{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    border-top: 1px solid #D9D9D9;
    padding: 20px 0;
    margin:0 30px
  }
  .checkbox-container {
    display: flex;
    align-items: center;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: flex-end;
    width: fit-content;
  }
  .checkbox-label img{
    margin-right:8px;
  }
  .checkbox-input {
    display: none;
  }

  .checkbox-custom {
    width: 14px;
    height: 14px;
    border: 1px solid #D7D7D7;
    border-radius: 2px;
    margin-right: 6px;
    display: block;
    position: relative;
    background-size: cover;
  }
  .checkbox-custom-text{
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    color:#646464;
  }
  .btm .close_box button{
    padding:8px 16px;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px; 
    color:#464f60;
    background:#EBEBF8;
    border-radius:4px;
  }

  /* 디테일*/
  .header div{display:flex; align-items: center; gap:8px;}
  .content .view_detail img {width:100%;}
  .content .view_detail > button{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    background: #5959EF;
    border-radius:4px;
    gap:4px;
    padding:8px;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px; 
    color:#fff;
  }
  .content .view_detail > button *{color:#fff;}
  .content .view_detail{margin:0 30px;}
  .content .view_detail > ul{display:flex; flex-direction:column; gap:20px; border-top:1px solid #D9D9D9; padding:20px 0;}
  .content .view_detail > ul li{display:flex; align-items:center; gap:25px;}
  .content .view_detail > ul li h5{width:60px;font-size: 15px;
    font-weight: 400;
    line-height: 22px;color:#464f60;}
  .content .view_detail > ul li p{font-size: 15px;
    font-weight: 400;
    line-height: 22px; color:#464f60;}
  .content .view_detail > ul li p:before{content:""; display:inline-block; margin:0 12px; width:1px; height:10px; background:#d9d9d9;}
  .content .view_detail > ul li p{display:flex; align-items:center;  }
  .content .view_detail > ul li p a{display:flex; align-items:center; gap:4px; color:#5959EF; border-bottom: 1px dotted #5959ef; }

  @media (max-width: 767px) {
    width:100%;
    max-height: 100dvh;
    border-radius:0;
    .header{padding:20px 20px 0 20px}
    .header h2{font-size:20px;}
    .tag_list{margin:0 20px;}
    .content .ebooth_desc{margin:0 20px 20px 20px}
    .ebooth_content_inner{margin-bottom:30px;}
    .content_cont h3{margin:0 20px 20px 20px}
    .content_cont span{margin: 0 20px 24px 20px;}
    .content_cont_inner{margin-right:20px;}
    .content_list{flex-wrap: nowrap; column-gap:12px; margin:0; margin-left:20px; padding-bottom:20px; overflow-x:auto; overflow-y:hidden;}
    .btm{margin:0 20px;}
    .content .view_detail{padding:0 20px;}
  }


  .content .view_detail .pdf-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-x: auto;
    overflow-y: auto; /* 세로 스크롤 활성화 */
    max-width: 100%;
    height: 100%;
    padding: 20px;
  }
  
  .content .view_detail .pdf-page {
    max-width: none !important;
    display: flex;
    justify-content: flex-start;
    transform-origin: left top !important;
    margin-bottom: 15px;
    transition: transform 0.2s ease; /* 트랜지션 효과 추가 */
  }
  
  .content .view_detail .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .content .view_detail .react-pdf__Page {
    max-width: none !important;
    transition: transform 0.2s ease; /* 트랜지션 효과 추가 */
  }
  
  .content .view_detail .react-pdf__Page__textContent {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
  .content .view_detail .react-pdf__Page__canvas {
    display: block;
    margin: 0 auto;
  }
  
  .content .view_detail .page-navigation {
    width:100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 20px;
  }
  .content .view_detail .page-navigation .nav-controls span{
    font-size:15px;
    line-height:22px;
    color:#404040;
    font-weight:400;
  }
  .content .view_detail .page-navigation button {
    padding: 8px 8px;
    font-size: 14px;
    background: #f3f2ff;
    border-radius: 4px;
    cursor: pointer;
    border: none;
  }
  
  .content .view_detail .page-navigation button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .content .view_detail .pdf-loading,
  .content .view_detail .pdf-error {
    width: 100%;
    padding: 50px 0;
    text-align: center;
    font-size: 16px;
    color: #646464;
  }

  .content{
    .view_detail{
      .pdf-container {
        overflow-x: auto;
        width: 100%;
        max-width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        height: 100%;
        padding: 20px;
        
        .react-pdf__Document {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        
        .pdf-page {
          max-width: none !important;
          margin-bottom: 15px;
          transform-origin: left top !important;
        }
      }
    }
  }

  .content .view_detail .page-loading {
    width: 100%;
    padding: 100px 0;
    text-align: center;
    font-size: 16px;
    color: #404040;
    background: #f8f8ff;
    border-radius: 8px;
    margin: 20px 0;
  }
`;

const ContentModalStyled = styled.div`
  .pdf-container {
    max-height: 75vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-y: auto;
    overflow-x: auto;
  }
  
  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .pdf-page {
    margin-bottom: 15px;
    transform-origin: left top;
    max-width: none !important;
  }
`;


